const normalizeLabel = (element) => (element?.innerText || element?.textContent || '')
  .replace(/\s+/g, ' ')
  .trim()
  .toLocaleLowerCase('pt-BR');

export const isBackNavigationTrigger = (element) => (
  element?.dataset?.navigation === 'back' || normalizeLabel(element) === 'voltar'
);
